import { createSelector } from '@ngrx/store';

import { selectDecoratorsState } from './decorators.selector';
import { ReferenceEditor } from '../../models';

export const getIsReferenceEditorClicked = createSelector(
  selectDecoratorsState,
  ({ referenceEditor }): ReferenceEditor => referenceEditor
);
